export default axios => ({
  /**
   * Список площадок
   *
   * @param pageSize
   * @param currentPage
   * @param searchBy
   * @param sort
   * @param order
   * @returns {*}
   */
  list ({ pageSize = 10, currentPage = 1, searchBy = '', sort = 'id', order = 'DESC' } = {}) {
    const params = {
      pageSize: pageSize,
      pageIndex: currentPage,
      search: searchBy,
      sort: sort,
      order: order
    }

    return axios.get('/web/playground/list', { params })
  },
  /**
   * Список площадок на карте
   *
   * @returns {*}
   */
  dots () {
    return axios.get('/web/playground/maps')
  },
  /**
   * Возвращает данные площадки
   *
   * @param id
   * @returns {*}
   */
  field (id) {
    return axios.get(`/web/playground/get/${id}`)
  },
  /**
   * Список событий площадки
   *
   * @param id
   * @param pageSize
   * @param currentPage
   * @param searchBy
   * @param sort
   * @param order
   * @returns {*}
   */
  events ({ id, pageSize = 10, currentPage = 1, searchBy = '', sort = 'id', order = 'DESC' } = {}) {
    const params = {
      pageSize: pageSize,
      pageIndex: currentPage,
      search: searchBy,
      sort: sort,
      order: order
    }

    return axios.get(`/web/playground/get/${id}/events`, { params })
  },
  /**
   * Список комментарии
   *
   * @param id
   * @param pageSize
   * @param currentPage
   * @param sort
   * @param order
   * @returns {*}
   */
  comments ({ id, pageSize = 10, currentPage = 1, sort = 'id', order = 'DESC' } = {}) {
    const params = {
      pageSize: pageSize,
      pageIndex: currentPage,
      sort: sort,
      order: order
    }

    return axios.get(`/web/playground/get/${id}/comments`, { params })
  },
  /**
   * Удаляет комментарии
   *
   * @param fieldId
   * @param commentId
   * @returns {*}
   */
  deleteComment ({ fieldId, commentId }) {
    return axios.delete(`/web/comment/playground/${fieldId}/comment/${commentId}`)
  },
  /**
   * Создает площадку
   *
   * @param body
   * @returns {*}
   */
  create (body) {
    return axios.post('/web/playground/add', body)
  },
  /**
   * Загрузка фотографий
   *
   * @param id
   * @param base64File
   * @returns {*}
   */
  photoUpload (id, base64File) {
    return axios.post(`/web/playground/get/${id}/photo`, { base64File })
  },
  /**
   * Поиск площадок
   *
   * @param text
   * @returns {*}
   */
  fieldsValueText (text) {
    return axios.get('/web/playground/search', {
      params: { search: text }
    })
  },
  /**
   * Редактируем данные площадки
   *
   * @param id
   * @param body
   * @returns {*}
   */
  change (id, body) {
    return axios.put(`/web/playground/get/${id}/edit`, body)
  },
  /**
   * Редактирует координаты площадки
   *
   * @param id
   * @param geocode
   * @returns {*}
   */
  changeGeocode (id, geocode) {
    return axios.put(`/web/playground/get/${id}/geocode`, { geocode })
  },
  /**
   * Возвращает список фотографии
   *
   * @param id
   * @returns {*}
   */
  photos (id) {
    return axios.get(`/web/playground/get/${id}/photos`)
  },
  /**
   * Удаление фотографии
   *
   * @param fieldId
   * @param photoId
   * @returns {*}
   */
  deletePhoto (fieldId, photoId) {
    return axios.delete(`/web/playground/get/${fieldId}/photo/${photoId}`)
  },
  /**
   * @returns {*}
   */
  coating () {
    return axios.get('/web/playground/get/1/edit/option')
  }
})
